var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-adult-stock-list',{staticClass:"pt-adult-stock-list__withData",attrs:{"agentOrgs":_vm.agentOrgs}})}
var staticRenderFns = []

export { render, staticRenderFns }